import { useGroups } from "~/composable/useGroups";
import { useNuxtAuth } from "@kopf3/adapt-oidc-component";

export default defineNuxtRouteMiddleware(async to => {
    if (to.path === "/maintenance-planner") {
        const auth = useNuxtAuth();
        const { isInAuthorizedGroup } = useGroups(id => auth.hasGroup(id));

        if (!isInAuthorizedGroup()) {
            return navigateTo("/403");
        }
    }
});
